module.exports = __webpack_public_path__ + "static/media/bgm.2e3ec69.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bgm.mp3
// module id = rPdT
// module chunks = 1